import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddDocumentRequest } from '../models/request/document/AddDocumentRequest';
import { GetDocumentListPagingAndFilterRequest } from '../models/request/document/GetDocumentListPagingAndFilterRequest';

export class DocumentService {
    static async getDocumentList(_menuName: string | undefined) {
        try {
            var inputObj = {
                menuName: _menuName
            };

            console.log('SERVICE CALL - getDocumentList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Document/getDocumentList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async downloadReport(_menuName: string, _entityId: string | undefined, _documentName: string) {
        try {
            var inputObj = {
                menuName: _menuName,
                entityId: _entityId,
                documentName: _documentName
            };

            console.log('SERVICE CALL - DownloadReport', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Document/DownloadReport', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportDocumentList(inputObj: GetDocumentListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportDocumentList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Document/exportDocumentList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getDocumentListPagingAndFilter(inputObj: GetDocumentListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetDocumentListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Document/GetDocumentListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static getFormData(obj: any = {}, formData = new FormData(), key = '') {
        if (!([Array, File, Object].includes(obj.constructor))) {
            return formData;
        }

        // Handle File recursive
        if (obj instanceof File) {
            formData.append(key, obj);
            return formData;
        }

        for (const prop in obj) {
            // Validate value type
            if (obj[prop] && !([String, Number, Boolean, Array, Object, File].includes(obj[prop].constructor))) {
                continue;
            }

            // Set deep index of prop
            const deepKey = key ? key + `.${prop}` : prop;

            // Handle array
            if (Array.isArray(obj[prop])) {
                obj[prop].forEach((item: any, index: any) => {
                    this.getFormData(item, formData, `${deepKey}[${index}]`);
                })
                continue;
            }

            (typeof obj[prop] === 'object' && obj[prop] && obj[prop].constructor === Object)
                ? this.getFormData(obj[prop], formData, deepKey) // Handle object
                : formData.append(deepKey, [undefined, null].includes(obj[prop]) ? '' : obj[prop]) // Handle string, number, boolean
        }

        return formData;
    }

    static async addDocument(inputObj: AddDocumentRequest) {
        try {
            const formData = this.getFormData(inputObj);

            console.log('SERVICE CALL - AddDocument', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Document/AddDocument', formData);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteDocument(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteDocument', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Document/deleteDocument', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getDocumentById(_id: string | null) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getDocumentById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Document/getDocumentById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getDocumentByAntrepoOfferId(_antrepoOfferId: string) {
        try {
            var inputObj = {
                antrepoOfferId: _antrepoOfferId
            };

            console.log('SERVICE CALL - getDocumentByAntrepoOfferId', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Document/getDocumentByAntrepoOfferId', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}